<template>
  <ul class="grid cols-5 gap-4">
    <li v-for="({ color, id, label }, i) in filter.options" :key="id + i">
      <vf-color-filter v-model="model" :id class="w-full" :color :value="id">
        {{ label }}
      </vf-color-filter>
    </li>
  </ul>
</template>

<script lang="ts" setup>
import type { ColorFilter } from '#types/filters'

defineProps<{
  filter: ColorFilter
  loading?: boolean
}>()

const model = defineModel<string[]>()
</script>
